/// <amd-module name="Widgets/BuildChartWidget/BuildChartWidget" />
import * as React from "react";
import { BuildHistogramWidgetWrapper } from "Widgets/BuildHistogramWidget/BuildHistogramWidgetWrapper";

import { VssComponent } from "VSS/Platform/Layout";

import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";

export class BuildChartWidget extends VssComponent<WidgetProps> {
    constructor(props: WidgetProps) {
        super(props);
    }

    public render(): JSX.Element {
        let buildDefinitionId = -1;
        if (this.props.settings) {
            const parsedSettings = JSON.parse(this.props.settings);
            buildDefinitionId = parsedSettings ? parsedSettings.id : buildDefinitionId;
        }

        return <BuildHistogramWidgetWrapper buildChartDefinitionId={buildDefinitionId} {...this.props} />;
    }
}

VssComponent.register("buildChartWidget", BuildChartWidget);
